import Email from "../components/email"

export const apps_01 =
<div>
<p>
    App para llevar las cuentas de tu hogar o de tu grupo de amigos o familiares. Lleva el balance de gastos conjuntos y préstamos personales; úsala en el hogar, en tus viajes y mucho más.
    Disponible en <b>Android</b>, <b>Windows</b> y próximamente en <b>iOS</b>.
</p>
<p className='subTituloSeccion'>
    Ejemplos de uso:
</p>
<p>
    ¿Compartes los gastos de tu hogar con tu pareja o familiar(es)?, aquí podrás registrar los gastos que cada integrante asumió y qué parte le correspondía a cada uno, así podrás llevar un registro organizado y podrás saber cuál es el balance correspondiente.
</p>
<p>
    ¿Prestaste dinero a un amigo o familiar y te lo están pagando por partes (o viceversa)?, registra el valor prestado y los pagos para saber el valor que te deben (o que debes) a la fecha.
</p>
<p>
    ¿Vas de viaje o se organizó una fiesta y cada integrante asumió diferentes gastos?, registra los valores y clarifica las deudas.
</p>
<p className='subTituloSeccion'>
    Generalidades:
</p>
<p>
    Esta App es bastante sencilla y todos sus componentes fueron desarrollados con recursos gratuitos por una sola persona. Requieres tener conexión a internet para utilizarla. No tiene costo y está libre de publicidad. Es compatible con el modo oscuro de tu dispositivo.
</p>
<p className='subTituloSeccion'>
    Términos de uso y política de privacidad:
</p>
<p>
    No se usarán los datos que guardas con ningún fin diferente al del uso de la App. La autenticación está asociada directamente al e-mail con el que te registraste, cualquier persona con acceso a tu e-mail puede interactuar con la App, cuando utilizas la función de cerrar la sesión en otros dispositivos, se aplicará en éstos si la App está cerrada o una vez se cierre. Utiliza las funciones para realizar copias de tus balances, no podré hacerme responsable por la pérdida de tus datos.
</p>
<p>
    Actualmente puedes agregar los grupos que desees que pueden tener hasta 50 integrantes cada uno, en cada grupo se pueden agregar hasta 200 movimientos (hay funciones que te permiten seguir llevando tus cuentas cuando llegas a este límite), estas condiciones pueden cambiar de acuerdo con la cantidad de usuarios de la App en favor de mantenerla libre de costos. Nunca se realizarán cobros, pero es posible que en determinado momento se requiera incluir un mínimo de publicidad para mantener los recursos que permiten que la App exista.
</p>
<p className='subTituloSeccion'>
    Soporte y contacto:
</p>
<p>
    <Email email="cuentas.claras.tool@gmail.com"></Email>
</p>
<p id='descargasSection' className='subTituloSeccion'>
    Descargas:
</p>
<b>Android:</b> 
<ul>
    <li>
        <b>Descarga Directa</b>: <a href={process.env.PUBLIC_URL + "/descargas/developernico.cuentasclaras.apk"}>Aquí</a>.
        Ten en cuenta que debes activar la opción para instalar aplicaciones desde fuentes desconocidas en tu dispositivo Android: <a href="https://espanol.verizon.com/support/knowledge-base-222177/" target="_blank" rel="noreferrer">Más información</a>. Te garantizo
        que esta App no es perjudicial para tu dispositivo.
    </li>
    <li>
        <b>Amazon</b> Appstore App For Android: <a href="http://www.amazon.com/gp/mas/dl/android?asin=B0BWSMNFKR" target="_blank" rel="noreferrer">Aquí</a>. Nombre global 
        de la App: <span style={{fontStyle: "italic"}}>Personal Shared Balances</span>. No olvides que para usar esta Appstore por primera vez, debes descargarla considerando la opción nombrada
        en el punto anterior acerca de la instalación de aplicaciones desde fuentes desconocidas.
    </li>
    <li>
        <b>Play Store</b>: Desafortunadamente no ha sido posible publicar esta aplicación allí, después de haber pagado la tarifa de desarrollador, Google no validó mi
        identificación corrrectamente y no me permitieron publicar aplicaciones incluso después de colocar muchos casos de soporte, solicité reembolso del dinero
        y me respondieron que no podían hacerlo porque no pudieron validar mi identificación (irónico y frustrante), si sabes cómo puedo solucionar esto te agradezco me contactes.
    </li> 
    
</ul>
    <b>Windows: </b>A través de Microsoft Store: <a href="https://www.microsoft.com/store/apps/9P2RSC7QZ2H8" target="_blank" rel="noreferrer">Aquí</a>.
</div>
